

(function( ){
//------------------------------------------------------------------------------------------------------------------------------


	var Main = function( )
	{
		var _this = this , i ;

		//  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -

		// この中に処理を書いていってください。
		$('.acd-btn').click(function(){
			if($(this).hasClass('open')){
				$(this).next().slideUp();
				$(this).removeClass('open');
			}else{
				$(this).next().slideDown();
				$(this).addClass('open');
			}
		});

		$(".zoom-img").zoomer();



		$(window).on('load', function() {
			$('img.map-image').imgViewer2({
				zoomMax: 5
			});
		});
		var mapOverlay = $('.venue-map').find('.overlay');
		var clickEventType = ((window.ontouchstart !== null) ? 'mouseenter' : 'touchstart');

		$(document).on(clickEventType, '.leaflet-container', function() {
			mapOverlay.css({
				'opacity': 0
			});
			$.cookie('overlay', 'hide', {
				path: '/'
			});
		});

		$(document).on(clickEventType, '.zoom-img', function() {
			mapOverlay.css({
				'opacity': 0
			});
			$.cookie('overlay', 'hide', {
				path: '/'
			});
			$('.zoomer').addClass('stop')
		});



		//  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -  -

		// リサイズイベントを使うときは、この_onResize内に処理を書いてください。
		// リサイズイベントを綱わないようでしたら決してください。
		// var _onResize = function( )
		// {

		// }

		// _onResize( ) ;
		// FitContents.addTask( _onResize ) ;
	}


//------------------------------------------------------------------------------------------------------------------------------


	window.requestAnimationFrame = 	window.requestAnimationFrame ||
									window.webkitRequestAnimationFrame ||
									function( func ){ return setTimeout( func , 1000/60 ) ; } ;


	window.cancelAnimationFrame = 	window.cancelAnimationFrame ||
									window.webkitCancelAnimationFrame ||
									function( id ){ clearTimeout( id ) ; } ;


	document.readyState === "complete"
		? setTimeout( function(){ new Main( ) ; } , 1 )
		: document.addEventListener( "DOMContentLoaded", function(){ new Main( ) ; } ) ;


//------------------------------------------------------------------------------------------------------------------------------


} )( ) ;
